import { funcProto } from '../context'
const { toString: nativeFuncToString } = funcProto
export default nativeFuncToString
